export enum Language {
  EnUS = 'en_US',
  JaJP = 'ja_JP',
  ZhHK = 'zh_HK',
}

export const DEFAULT_LANGUAGE = Language.EnUS

export enum CountryId {
  HK = 84,
  JP = 99,
  MO = 132,
  MY = 140,
  TH = 191,
  TW = 199,
  CN = 217,
  US = 203,
}

export function normalizeLanguage(language: string) {
  if (language.includes('ja')) return Language.JaJP
  if (language.includes('zh')) return Language.ZhHK
  if (language.includes('en')) return Language.EnUS

  return Language.EnUS
}
